// Module 1
import IdentityIntroVideo from "./Module1/IdentityIntroVideo";
import IdentityValueVisionVideo from "./Module1/IdentityValueVisionVideo";
import PromotoableProfVideo from "./Module1/PromotoableProfVideo";
import ControllablesVideo from "./Module1/ControllablesVideo";

// Module 2
import IdentityValueVideo from "./Module2/IdentityValueVideo";
import IdentityVisionVideo from "./Module2/IdentityVisionVideo";

// Module 3
import StakeholdersAndVisibilityVideo from "./Module3/StakeholdersAndVisibilityVideo";
import StakeholderVideo from "./Module3/StakeholderVideo";
import WhatsInItForMeVideo from "./Module3/WhatsInItForMeVideo";
import WhatsInItForThemVideo from "./Module3/WhatsInItForThemVideo";
import TacticsToGetVisibilityVideo from "./Module3/TacticsToGetVisibilityVideo";
import VisibilityVideo from "./Module3/VisibilityVideo";

// Module 4
import PresenceVideo from "./Module4/PresenceVideo";
import PressureVideo from "./Module4/PressureVideo";
import PromotionSignalsVideo from "./Module4/PromotionSignalsVideo";
import MeetingAsStageVideo from "./Module4/MeetingAsStageVideo";
import InnerSaboteursInMeetingsVideo from "./Module4/InnerSaboteursInMeetingsVideo";

// Module 5
import BadBossesVideo from "./Module5/BadBossesVideo";
import LeverageVideo from "./Module5/LeverageVideo";
import MindsetBlockersVideo from "./Module5/MindsetBlockersVideo";
import LnoFrameworkVideo from "./Module5/LnoFrameworkVideo";
import AskForResourcesVideo from "./Module5/AskForResourcesVideo";

// Module 6
import BelievingYouAreNextLevelVideo from "./Module6/BelievingYouAreNextLevelVideo";
import EssenceOfAPersonalBrandVideo from "./Module6/EssenceOfAPersonalBrandVideo";
import HowToBuildYourBrandVideo from "./Module6/HowToBuildYourBrandVideo";
import ConsciousNetworkingVideo from "./Module6/ConsciousNetworkingVideo";

// Module 7
import LossAversionVideo from "./Module7/LossAversionVideo";
import TooValuableVideo from "./Module7/TooValuableVideo";
import PromotionPsychologyFunnelVideo from "./Module7/PromotionPsychologyFunnelVideo";
import PsychologyLeversVideo from "./Module7/PsychologyLeversVideo";
import HowToPitchVideo from "./Module7/HowToPitchVideo";

export const videoRegistry = {
  "career_progression/identity/identity_intro/video": IdentityIntroVideo,
  "career_progression/identity/identity_value_vision/video": IdentityValueVisionVideo,
  "career_progression/identity/promotoable_prof/video": PromotoableProfVideo,
  "career_progression/identity/controllables/video": ControllablesVideo,

  "career_progression/vision/identity_value/video": IdentityValueVideo,
  "career_progression/vision/identity_vision/video": IdentityVisionVideo,

  "career_progression/interpersonal/stakeholder/video": StakeholderVideo,
  "career_progression/interpersonal/stakeholders_and_visibility/video": StakeholdersAndVisibilityVideo,
  "career_progression/interpersonal/whats_in_it_for_me/video": WhatsInItForMeVideo,
  "career_progression/interpersonal/whats_in_it_for_them/video": WhatsInItForThemVideo,
  "career_progression/interpersonal/tactics_to_get_visibility/video": TacticsToGetVisibilityVideo,
  "career_progression/interpersonal/visibility/video": VisibilityVideo,

  "career_progression/presence/presence/video": PresenceVideo,
  "career_progression/presence/pressure/video": PressureVideo,
  "career_progression/presence/promotion_signals/video": PromotionSignalsVideo,
  "career_progression/presence/meeting_as_stage/video": MeetingAsStageVideo,
  "career_progression/presence/inner_saboteurs_in_meetings/video": InnerSaboteursInMeetingsVideo,


  "career_progression/interpersonal/bad_bosses/video": BadBossesVideo,
  "career_progression/becoming/leverage/video": LeverageVideo,
  "career_progression/becoming/mindset_blockers/video": MindsetBlockersVideo,
  "career_progression/becoming/lno_framework/video": LnoFrameworkVideo,
  "career_progression/becoming/ask_for_resources/video": AskForResourcesVideo,

  "career_progression/delegation/believing_you_are_next_level/video": BelievingYouAreNextLevelVideo,
  "career_progression/delegation/essence_of_a_personal_brand/video": EssenceOfAPersonalBrandVideo,
  "career_progression/delegation/how_to_build_your_brand/video": HowToBuildYourBrandVideo,
  "career_progression/delegation/conscious_networking/video": ConsciousNetworkingVideo,

  "career_progression/refinement/loss_aversion/video": LossAversionVideo,
  "career_progression/refinement/too_valuable/video": TooValuableVideo,
  "career_progression/refinement/promotion_psychology_funnel/video": PromotionPsychologyFunnelVideo,
  "career_progression/refinement/psychology_levers/video": PsychologyLeversVideo,
  "career_progression/refinement/how_to_pitch/video": HowToPitchVideo,
};
